var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('nuxt-link',{staticClass:"logo",attrs:{"to":"/"}},[_c('Logo',{attrs:{"viewBox":"0 0 421 77"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }